import React, {Component} from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {DayPickerSingleDateController} from "react-dates";
import moment from "moment";
import "./app.css";
import isBefore from "date-fns/is_before";
import "moment/locale/es";
import "moment/locale/de";
import "moment/locale/ca";
import * as queryString from "query-string";
import {addLocaleData, FormattedMessage, IntlProvider} from "react-intl";


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment()
    };
    this.setNewDate = this.setNewDate.bind(this);
    App.goToLink = App.goToLink.bind(this);
  }

  componentDidMount() {
    moment.locale(navigator.language.toLowerCase().split(/[_-]+/)[0]);

  }

  static getMessagesAndImportLangs(lang) {

    if (lang != "en") {
      addLocaleData(require(`react-intl/locale-data/${lang}`));
      const messages = require(`./static/locales/${lang}`);
      return {...messages}
    } else {
      return null;
    }
  }

  setNewDate(date) {
    this.setState({
      date: date
    })
  }

  static goToLink() {
    const {date} = this.state
    const formattedDate = date.format('YYYY-MM-DD').toString();
    const parsed = queryString.parse(window.location.search );
    window.top.location.href = `https://${parsed.urlRedirect}&utm_medium=${parsed.utm_medium}&utm_source=${parsed.utm_source}&utm_campaign=${parsed.utm_campaign}${formattedDate ? `&date=${formattedDate}`:''}`;
  }

  static isOutOfRange(date) {
    return isBefore(date, new Date());
  }

  render() {
    const currentLang = navigator.language.toLowerCase().split(/[_-]+/)[0]
    let messagesAll = [];
    if (currentLang) {
      messagesAll = App.getMessagesAndImportLangs(currentLang);
    }

    return (
      <IntlProvider
        locale={currentLang}
        messages={messagesAll}
      >
        <div className="App">
          <div className="Calendar">
            <DayPickerSingleDateController
              date={this.state.date} // momentPropTypes.momentObj or null
              onDateChange={date => this.setNewDate(date)} // PropTypes.func.isRequired
              focused={this.state.focused} // PropTypes.bool
              onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
              //id="your_unique_id" // PropTypes.string.isRequired,
              numberOfMonths={1}
              isOutsideRange={App.isOutOfRange}
              hideKeyboardShortcutsPanel
            />
            <button onClick={App.goToLink} className="btn btn-default"><FormattedMessage
              id={"button.check.availability"} defaultMessage={"Check availability"}/></button>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js